import * as React from 'react';

const SvgAlertCircleColor = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#F4DB6F", d: "M22 12c0 5.51-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2s10 4.49 10 10Z", style: {
    fill: "#f4db6f"
  } }),
  React.createElement("path", { fill: "#2D2E2E", d: "M11 7h2v6h-2V7Zm1 7.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" })
);

export { SvgAlertCircleColor as default };
//# sourceMappingURL=AlertCircleColor.es.js.map
